import { Moment } from 'moment'

import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

import { InvoiceEmailTransmissionStatus } from 'Portals/Internal/constants'

export enum CustomerInvoiceListResultFields {
	searchByName = 'searchByName'
}

export enum CustomerInvoiceListFilterFields {
	startDate = 'startDate',
	endDate = 'endDate',
	billingAgency = 'billingAgency',
	status = 'status',
	programManager = 'programManagerId',
	showInProcessOnly = 'showInProcessOnly',
	showMyServiceTeamOnly = 'showMyServiceTeamOnly',
	accountAdministratorId = 'accountAdministratorId',
	customerInvoiceExternalId = 'customerInvoiceExternalId',
	searchPeriod = 'searchPeriod',
	exceptionType = 'exceptionType',
	exception = 'exception',
	exceptionsOnly = 'isExceptionOnly',
	exceptionAssignedTo = 'exceptionAssignedTo',
	overdueOnly = 'overdueOnly',
	statusReasonCode = 'statusReasonCode'
}

export interface ContractsSearchSuggestions {
	searchByCode: Entity[]
	searchByCustomerId: Array<Entity & { customer: Entity }>
	searchByCustomerName: Array<Entity & { customer: Entity }>
	searchByServiceSiteId: Array<Entity & { serviceSite: Entity }>
	searchByCompanyId: Array<Entity & { company: Entity }>
	searchByBillingAgency: Array<Entity & { billingAgency: Entity }>
}

export enum CustomerInvoiceListLabels {
	Id = 'id',
	Name = 'name',
	Address = 'address',
	ApprovedBy = 'approvedBy',
	AmountLeft = 'amountLeft',
	ActualServiceDate = 'actualServiceDate',
	AdjustmentReason = 'adjustmentReason',
	AccountingDate = 'accountingDate',
	BillingAgency = 'billingAgency',
	BillingAddress = 'billingAddress',
	BillingItemId = 'billingItemId',
	BillOfLading = 'billOfLading',
	BillingPrice = 'billingPrice',
	BillingQuantity = 'billingQuantity',
	BillingItemNotes = 'billingItemNotes',
	BackupDocuments = 'backupDocuments',
	BaseCurrency = 'baseCurrency',
	InvoiceDate = 'invoiceDate',
	InvoiceType = 'invoiceType',
	InvoiceContact = 'invoiceContact',
	InvoiceContactId = 'invoiceContactId',
	InvoiceStatus = 'invoiceStatus',
	InvoiceStatusId = 'invoiceStatusId',
	InvoiceAdjustmentReason = 'invoiceAdjustmentReason',
	InvoiceStatusReason = 'invoiceStatusReason',
	InvoiceStatusReasonCode = 'invoiceStatusReasonCode',
	InternalComments = 'internalComments',
	ItemRefCode = 'itemRefCode',
	ItemDescription = 'itemDescription',
	ItemTotal = 'itemTotal',
	InvoiceScanId = 'invoiceScanId',
	Items = 'items',
	IsLateFee = 'isLateFee',
	DocumentName = 'documentName',
	DocumentType = 'documentType',
	BlanketPoId = 'blanketPoId',
	Contract = 'contract',
	Unit = 'unit',
	UnitPrice = 'unitPrice',
	UnitOfMeasure = 'unitOfMeasure',
	UnitOfMeasureId = 'unitOfMeasureId',
	UpdateTransactionPounds = 'updateTransactionPounds',
	TotalInvoiceAmount = 'totalInvoiceAmount',
	TransactionCurrency = 'transactionCurrency',
	TransactionId = 'transactionId',
	Team = 'team',
	LatestEmailStatus = 'latestEmailStatus',
	LessTotalInvoiceAmount = 'lessTotalInvoiceAmount',
	LessModifiedExtendedPrice = 'lessModifiedExtendedPrice',
	LineItems = 'lineItems',
	LineItemTotal = 'lineItemTotal',
	ProgramManagers = 'programManagers',
	Number = 'number',
	Net = 'net',
	ExchangeRate = 'exchangeRate',
	EffectiveStartDate = 'effectiveStartDate',
	EffectiveEndDate = 'effectiveEndDate',
	CreateDate = 'createDate',
	Currency = 'currency',
	CurrencyId = 'currencyId',
	TransactionCurrencyId = 'transactionCurrencyId',
	TotalPrice = 'totalPrice',
	CustomBillFreqCode = 'customBillFreqCode',
	CustomBillFreqCodeId = 'customBillFreqCodeId',
	CustomerInvoiceStatusReason = 'customerInvoiceStatusReason',
	CustomerInvoiceStatus = 'customerInvoiceStatus',
	CustomerInvoiceItems = 'customerInvoiceItems',
	CustomerSendDate = 'customerSendDate',
	CustomerReceivedDate = 'customerReceivedDate',
	CustomerInvoiceTotal = 'customerInvoiceTotal',
	CustomerInvoiceItem = 'customerInvoiceItem',
	CustomerCurrencyCode = 'customerCurrencyCode',
	ChargeType = 'chargeType',
	ChargeTypeId = 'chargeTypeId',
	Customer = 'customer',
	Comments = 'comments',
	City = 'city',
	Pounds = 'pounds',
	PurchaseOrder = 'purchaseOrder',
	PurchaseOrderId = 'purchaseOrderId',
	PurchaseOrderRequired = 'purchaseOrderRequired',
	PurchaseOrderNumber = 'purchaseOrderNumber',
	PmInvoiceReviewComments = 'pmInvoiceReviewComments',
	ReferencesInvoiceIds = 'referencesInvoiceIds',
	ReferencedByInvoiceIds = 'referencedByInvoiceIds',
	ReferenceCustomerInvoiceId = 'referenceCustomerInvoiceId',
	RateExtendedPrice = 'rateExtendedPrice',
	ReportId = 'reportId',
	ModifiedQuantity = 'modifiedQuantity',
	ModifiedBillingPrice = 'modifiedBillingPrice',
	ModifiedExtendedPrice = 'modifiedExtendedPrice',
	MarginPercentage = 'marginPercentage',
	Margin = 'margin',
	ManifestId = 'manifestId',
	OriginalExtendedPrice = 'originalExtendedPrice',
	State = 'state',
	ServiceSiteId = 'serviceSiteId',
	ServiceOccurrenceId = 'serviceOccurrenceId',
	SupplierInvoiceTotal = 'supplierInvoiceTotal',
	SupplierInvoiceItem = 'supplierInvoiceItem',
	SupplierInvoiceNumber = 'supplierInvoiceNumber',
	SupplierInvoiceId = 'supplierInvoiceId',
	ScanRecordId = 'scanRecordId',
	ServiceSite = 'serviceSite',
	ServiceDate = 'serviceDate',
	Status = 'status',
	ZIP = 'zip',
	CustomerInvoiceAdjustments = 'customerInvoiceAdjustments',
	Quantity = 'quantity',
	CustomerExternalInvoice = 'customerExternalInvoice',
	efacturaInternalComments = 'efacturaInternalComments',
	customerFacturaNumber = 'customerFacturaNumber',
	facturaReceiptDate = 'facturaReceiptDate',
	pedimentoNumber = 'pedimentoNumber',
	pedimentoDate = 'pedimentoDate',
	InvoiceEmailTransmissionStatus = 'invoiceEmailTransmissionStatus',
	StatusChangeDate = 'statusChangeDate',
	Reason = 'reason',
	exceptionAssignedTo = 'exceptionAssignedTo',
	invoiceDateUpdateDate = 'invoiceDateUpdateDate',
	invoiceDateUpdateBy = 'invoiceDateUpdateBy',
	isRebill = 'isRebill',
	invoiceType = 'invoiceType',
	ItemId = 'itemId',
	averageQuantity = 'averageQuantity',
	agingReason = 'agingReason',
	overdueDays = 'overdueDays',
	isOverdue = 'isOverdue',
	serviceSites = 'serviceSites',
	eFacturaNumber = 'eFacturaNumber',
	HasInvoiceContact = 'hasInvoiceContact',
	displayZeroItems = 'displayZeroItems',
	makeSupplierServiceOccurrenceCancelled = 'makeSupplierServiceOccurrenceCancelled'
}

export enum CustomerInvoiceListSearchResultFields {
	ids = 'ids',
	customerIds = 'customerIds',
	customeNames = 'customeNames',
	serviceSiteIds = 'serviceSiteIds',
	serviceSiteNames = 'serviceSiteNames',
	serviceSiteRefCodes = 'serviceSiteRefCodes',
	contractCodes = 'contractCodes',
	companyNames = 'companyNames',
	companyIds = 'companyIds',
	itemIds = 'itemIds'
}

export enum CustomerInvoiceListExtraSearchFields {
	accountAdminId = 'accountAdminId',
	programManagerId = 'programManagerId',
	efactura = 'efactura',
	customerfactura = 'customerfactura'
}

export enum CustomerInvoiceType {
	adjustment = 'adjustment'
}

export enum ExceptionFormType {
	exception = 'exception',
	comment = 'comment'
}

export enum CustomerInvoiceStatusLabels {
	initiated = 'initiated',
	customerReviewApproval = 'cust review approval',
	onHold = 'on hold',
	readyToPrint = 'ready to print',
	spocReviewApprovalIncluded = 'spoc review approval'
}

export enum InvoiceStatusForExceptionComments {
	initiated = 'initiated',
	spocReviewApprovalIncluded = 'spoc review approval',
	onHold = 'on hold',
	exception = 'exception'
}

export type ExceptionType = Entity & { exceptions: Entity[] }

export declare namespace CustomerInvoice {
	interface Basic {
		[CustomerInvoiceListLabels.Id]: number
		[CustomerInvoiceListLabels.BillingAgency]: Entity | null
		[CustomerInvoiceListLabels.BlanketPoId]: number | null
		[CustomerInvoiceListLabels.Contract]: Entity | null
		[CustomerInvoiceListLabels.InvoiceDate]: string
		[CustomerInvoiceListLabels.TotalInvoiceAmount]: number
		[CustomerInvoiceListLabels.LatestEmailStatus]: string
		[CustomerInvoiceListLabels.exceptionAssignedTo]: Entity | null
		[CustomerInvoiceListLabels.TransactionCurrency]: TransactionCurrency
		[CustomerInvoiceListLabels.ProgramManagers]: Entity[]
		[CustomerInvoiceListLabels.CustomerInvoiceStatusReason]: string | null
		[CustomerInvoiceListLabels.CustomerInvoiceStatus]: string | null
		[CustomerInvoiceListLabels.CustomerInvoiceItems]: CustomerInvoiceItems
		[CustomerInvoiceListLabels.Customer]: Customer
		[CustomerInvoiceListLabels.isRebill]: boolean
		[CustomerInvoiceListLabels.invoiceType]: Entity | null
		[CustomerInvoiceListLabels.isOverdue]: boolean
	}

	namespace Form {
		interface Edit {
			[CustomerInvoiceListLabels.CustomerSendDate]: Moment | null
			[CustomerInvoiceListLabels.CustomerReceivedDate]: Moment | null
			[CustomerInvoiceListLabels.InvoiceContactId]: BasicNumber | LabelValue<number>
			[CustomerInvoiceListLabels.TransactionCurrencyId]: number | null
			[CustomerInvoiceListLabels.InvoiceStatusId]: LabelValue<number> | null
			[CustomerInvoiceListLabels.InvoiceStatusReasonCode]: BasicString
			[CustomerInvoiceListLabels.CustomBillFreqCode]: LabelValue | null
			[CustomerInvoiceListLabels.PurchaseOrderId]: number | null
			[CustomerInvoiceListLabels.ApprovedBy]: BasicString
			[CustomerInvoiceListLabels.Comments]: BasicString
			[CustomerInvoiceListLabels.InternalComments]: BasicString
			[CustomerInvoiceListLabels.customerFacturaNumber]: BasicString
			[CustomerInvoiceListLabels.eFacturaNumber]: BasicString
			[CustomerInvoiceListLabels.facturaReceiptDate]: Moment | null
			[CustomerInvoiceListLabels.pedimentoDate]: Moment | null
			[CustomerInvoiceListLabels.pedimentoNumber]: BasicString
			[CustomerInvoiceListLabels.efacturaInternalComments]: BasicString
			[CustomerInvoiceListLabels.InvoiceDate]: Moment | BasicString
			[CustomerInvoiceListLabels.displayZeroItems]: boolean
		}

		interface Add {
			billingItemFormData: BillingItem.Form.Search
			billingItemIds: number[]
		}
	}

	namespace BillingItem {
		interface Basic {
			id: number
			serviceOccurrenceId: number
			serviceSite: Entity | null
			chargeType: Entity | null
			itemName: string | null
			quantity: number | null
			unitOfMeasure: Entity | null
			unitPrice: number | null
			extendedPrice: number | null
			actualServiceDate: string | null
		}
		namespace Form {
			interface Search {
				customer: LabelValue<number> | null
				serviceSite: LabelValue<number> | null
				remitToId: string | null
				invoiceTypeId: string | null
				customBillingFreqCode: LabelValue<number> | null
				currencyId: number | null
			}
		}
		namespace Request {
			interface Search {
				customerId: number | null
				serviceSiteId: number | null
				remitTo: number | null
				invoiceTypeId: number | null
				customBillingFreqCodeId: number | null
				currencyId: number | null
			}
		}
	}

	namespace BillingItemAtServices {
		interface Basic {
			id: number
			serviceOccurrenceId: number
			serviceSite: NullableEntity | null
			chargeType: NullableEntity | null
			itemName: string | null
			quantity: number | null
			unitOfMeasure: NullableEntity | null
			unitPrice: number | null
			totalPrice: number | null
			actualServiceDate: string | null
			customBillFreqCode: NullableEntity | null
			purchaseOrderNumber: string | null
			supplierLocations: NullableEntity[] | null
		}

		namespace Form {
			interface Search {
				serviceSiteId: number | null
				serviceDateFrom: Moment | null
				serviceDateTo: Moment | null
				restrictByCustomBillFreqCode: boolean
			}
			interface Add {
				billingItemIds: number[]
			}
		}

		namespace Request {
			interface Search {
				serviceSiteId: number | null
				serviceDateFrom: string | null
				serviceDateTo: string | null
				restrictByCustomBillFreqCode: boolean
			}
			interface Add {
				billingItemIds: number[]
			}
		}
	}

	namespace Request {
		interface Add {
			customerId: number | null
			billingAgencyId: number | null
			currencyId: number | null
			billingItemIds: number[] | null
		}
		interface Edit {
			[CustomerInvoiceListLabels.CustomerSendDate]: string | null
			[CustomerInvoiceListLabels.CustomerReceivedDate]: string | null
			[CustomerInvoiceListLabels.InvoiceContactId]: number | null
			[CustomerInvoiceListLabels.TransactionCurrencyId]: number | null
			[CustomerInvoiceListLabels.InvoiceStatusId]: number | null
			[CustomerInvoiceListLabels.InvoiceStatusReasonCode]: string | null
			[CustomerInvoiceListLabels.CustomBillFreqCodeId]: string | null
			[CustomerInvoiceListLabels.PurchaseOrderId]: number | null
			[CustomerInvoiceListLabels.Comments]: BasicString
			[CustomerInvoiceListLabels.InternalComments]: BasicString
			[CustomerInvoiceListLabels.efacturaInternalComments]: BasicString
			[CustomerInvoiceListLabels.customerFacturaNumber]: BasicString
			[CustomerInvoiceListLabels.facturaReceiptDate]: BasicString
			[CustomerInvoiceListLabels.pedimentoNumber]: BasicString
			[CustomerInvoiceListLabels.pedimentoDate]: BasicString
			[CustomerInvoiceListLabels.InvoiceDate]?: BasicString
			[CustomerInvoiceListLabels.displayZeroItems]: boolean
		}

		interface InvoiceAdjustment {
			description: BasicString
			solution: BasicString
		}
	}

	interface TransactionCurrency {
		id: number
		code: string
	}

	interface InvoiceAdjustmentCustomer extends Entity {
		purchaseOrderRequired: true
	}

	interface InvoiceAdjustmentBillingAddress {
		address: string
		city: string
		state: string
		zip: string
	}

	interface InvoiceStatusReason {
		code: string
		name: string
	}

	interface InvoiceAdjustmentPurchaseOrder {
		id: number
		purchaseOrderNumber: string
		amountLeft: number
		lessTotalInvoiceAmount: number
		lessModifiedExtendedPrice: number
		effectiveStartDate: string | null
		effectiveEndDate: string | null
	}

	interface InvoiceAdjustmentCustomerInvoiceItems {
		id: number
		averageQuantity: string | null
		billingItemId: number
		serviceSiteId: number
		actualServiceDate: string | null
		serviceOccurrenceId: number
		itemRefCode: string
		billOfLading: string
		itemDescription: string
		modifiedQuantity: number
		pounds: number
		unitOfMeasure: Entity
		modifiedBillingPrice: number
		modifiedExtendedPrice: number
		rateExtendedPrice: number
		currency: Entity
		chargeType: Entity
		serviceSite: ServiceSiteExtended
		originalExtendedPrice: number
		billingQuantity: number
		billingPrice: number
		updateTransactionPounds: number
		billingItemNotes: string
	}

	interface InvoiceAdjustmentCustomerExternalInvoice {
		id: number
		isCancellable: boolean
		isCancelled: boolean
		number: BasicString
	}

	interface CustomerInvoiceAdjustments {
		id: number
		number: string
		customer: InvoiceAdjustmentCustomer
		billingAddress: InvoiceAdjustmentBillingAddress
		approvedBy: string
		invoiceDate: string | null
		invoiceType: Entity
		accountingDate: string | null
		invoiceAdjustmentReason: Entity
		billingAgency: Entity
		baseCurrency: Entity
		transactionCurrency: Entity
		exchangeRate: number
		totalInvoiceAmount: number
		customerSendDate: string | null
		customerReceivedDate: string | null
		createDate: string | null
		invoiceContact: Entity
		invoiceStatus: Entity
		invoiceStatusReason: InvoiceStatusReason
		customBillFreqCode: Entity
		purchaseOrder: InvoiceAdjustmentPurchaseOrder
		comments: string
		internalComments: string
		pmInvoiceReviewComments: string[]
		referencesInvoiceIds: number[]
		referencedByInvoiceIds: number[]
		customerInvoiceItems: [InvoiceAdjustmentCustomerInvoiceItems]
		customerFacturaNumber: string
		facturaReceiptDate: string | null
		pedimentoNumber: string
		pedimentoDate: string | null
		efacturaInternalComments: string
		customerExternalInvoice: InvoiceAdjustmentCustomerExternalInvoice
	}

	interface Customer {
		id: number
		name: string | null
		peopleSoftCustomer: number | null
		company: Entity
		customerStatusId: number
		customerStatus: string | null
		customerReferenceCode: string | null
		billingAgencyId: number
		billingAgency: string | null
		billingCurrencyId: number
		billingCurrency: string | null
		manualInvoiceReview: boolean
		emailInvoiceToServiceSiteContacts: boolean
		allowSelectionOfCustomerReviewInvoiceStatus: boolean
		creditCardRequired: boolean
		purchaseOrderRequired: boolean
		sendStatement: boolean
		hesSharedCustomer: boolean
		statementComments: string
		emailInvoiceComments: string
		supplierLocationId: number
		supplierLocation: string | null
		taxCorporationCode: string
		rebateChecksIssued: boolean
		countryTaxNumber: string
		efacturaFormOfPayment: string
		efacturaCTA: string | null
		lastInvoiceDate: string | null
		customerUpdated: string
		lateFeesPercent: string | null
		efacturaUseCode: string | null
		efacturaPaymentMethod: string | null
		regimenFiscal: string | null
		vatOffice: string | null
		customerCompany: string | null
		groupCode: string | null
	}

	interface CustomerEntity extends Entity {
		[CustomerInvoiceListLabels.PurchaseOrderRequired]: boolean
	}

	interface CustomerInvoiceItems {
		id: number
		serviceSite: Entity
	}

	interface ServiceSiteExtended extends Entity {
		[CustomerInvoiceListLabels.Team]: Entity
	}

	interface CustomerInvoiceItemExtended {
		[CustomerInvoiceListLabels.Id]: number
		[CustomerInvoiceListLabels.BillingItemId]: number
		[CustomerInvoiceListLabels.ServiceSiteId]: number
		[CustomerInvoiceListLabels.ActualServiceDate]: BasicString
		[CustomerInvoiceListLabels.ServiceOccurrenceId]: number | null
		[CustomerInvoiceListLabels.ItemRefCode]: BasicString
		[CustomerInvoiceListLabels.BillOfLading]: BasicString
		[CustomerInvoiceListLabels.ItemDescription]: BasicString
		[CustomerInvoiceListLabels.ModifiedQuantity]: number
		[CustomerInvoiceListLabels.Pounds]: number
		[CustomerInvoiceListLabels.UnitOfMeasure]: Entity
		[CustomerInvoiceListLabels.ModifiedBillingPrice]: number
		[CustomerInvoiceListLabels.ModifiedExtendedPrice]: number
		[CustomerInvoiceListLabels.RateExtendedPrice]: number
		[CustomerInvoiceListLabels.Currency]: Entity | null
		[CustomerInvoiceListLabels.ChargeType]: Entity
		[CustomerInvoiceListLabels.ServiceSite]: ServiceSiteExtended
		[CustomerInvoiceListLabels.OriginalExtendedPrice]: number
		[CustomerInvoiceListLabels.BillingQuantity]: number
		[CustomerInvoiceListLabels.BillingPrice]: number
		[CustomerInvoiceListLabels.UpdateTransactionPounds]: number
		[CustomerInvoiceListLabels.BillingItemNotes]: BasicString
	}

	interface BillingAddress {
		[CustomerInvoiceListLabels.Address]: BasicString
		[CustomerInvoiceListLabels.City]: BasicString
		[CustomerInvoiceListLabels.State]: BasicString
		[CustomerInvoiceListLabels.ZIP]: BasicString
	}

	interface PurchaseOrder {
		[CustomerInvoiceListLabels.Id]: number
		[CustomerInvoiceListLabels.PurchaseOrderNumber]: BasicString
		[CustomerInvoiceListLabels.AmountLeft]: number | null
		[CustomerInvoiceListLabels.LessTotalInvoiceAmount]: number | null
		[CustomerInvoiceListLabels.LessModifiedExtendedPrice]: number | null
		[CustomerInvoiceListLabels.EffectiveStartDate]: BasicString
		[CustomerInvoiceListLabels.EffectiveEndDate]: BasicString
	}

	namespace Margin {
		interface Header {
			[CustomerInvoiceListLabels.CustomerCurrencyCode]: string
			[CustomerInvoiceListLabels.CustomerInvoiceTotal]: number
			[CustomerInvoiceListLabels.SupplierInvoiceTotal]: number
			[CustomerInvoiceListLabels.Net]: number
			[CustomerInvoiceListLabels.MarginPercentage]: number
		}

		interface Item {
			[CustomerInvoiceListLabels.CustomerInvoiceItem]: {
				[CustomerInvoiceListLabels.ServiceOccurrenceId]: number
				[CustomerInvoiceListLabels.LineItems]: string[] | null
				[CustomerInvoiceListLabels.ServiceSiteId]: number | null
				[CustomerInvoiceListLabels.ItemTotal]: number
			} | null
			[CustomerInvoiceListLabels.SupplierInvoiceItem]: {
				[CustomerInvoiceListLabels.ScanRecordId]: number
				[CustomerInvoiceListLabels.InvoiceScanId]: number
				[CustomerInvoiceListLabels.SupplierInvoiceNumber]: string | null
				[CustomerInvoiceListLabels.SupplierInvoiceId]: number | null
				[CustomerInvoiceListLabels.LineItems]: string[] | null
				[CustomerInvoiceListLabels.LineItemTotal]: number
			} | null
			[CustomerInvoiceListLabels.Margin]: number
		}

		interface Section extends Margin.Header {
			[CustomerInvoiceListLabels.Items]: Margin.Item[] | null
		}

		namespace MoveExpense {
			interface Basic {
				id: number
				serviceOccurrenceId: BasicNumber
				serviceSite: Entity | null
				chargeType: Entity | null
				item: Entity | null
				quantity: BasicNumber
				unitOfMeasure: Entity | null
				unitPrice: BasicNumber
				totalPrice: BasicNumber
				actualServiceDate: BasicString
				supplierLocation: Entity | null
			}
			namespace Form {
				interface Params {
					fromServiceOccurrenceId: number | null
					serviceDateFrom: Moment | null
					serviceDateTo: Moment | null
					restrictByItemId: boolean
				}
			}
			namespace Request {
				interface Params {
					toServiceOccurrenceId: number
					fromServiceOccurrenceId: number | null
					serviceDateFrom: string | null
					serviceDateTo: string | null
					restrictByItemId: boolean
					transactionCurrencyId: number
					billingAgencyId: number
					serviceSiteId: number
				}

				interface MoveExpense {
					serviceOccurrenceId: number
					billingItemId: number
				}
			}

			interface SearchSuggestionParams
				extends Pick<
					CustomerInvoice.Margin.MoveExpense.Request.Params,
					'transactionCurrencyId' | 'billingAgencyId'
				> {
				serviceSiteId: number
			}
		}
	}

	interface Notification {
		dismissedBy: DismissedBy | null
		dismissedDate: string | null
		id: number
		isDismissed: boolean
		message: string
	}

	interface DismissedBy {
		id: Key
		firstName: string
		lastName: string
	}

	interface Adjustment {
		[CustomerInvoiceListLabels.Id]: number
		[CustomerInvoiceListLabels.Number]: BasicString
		[CustomerInvoiceListLabels.InvoiceDate]: BasicString
		[CustomerInvoiceListLabels.TotalInvoiceAmount]: number
		[CustomerInvoiceListLabels.InvoiceType]: Entity
		[CustomerInvoiceListLabels.AdjustmentReason]: CodeEntity
		[CustomerInvoiceListLabels.Comments]: BasicString
		[CustomerInvoiceListLabels.Status]: Entity
		[CustomerInvoiceListLabels.ReferenceCustomerInvoiceId]: number[]
		[CustomerInvoiceListLabels.ReferencedByInvoiceIds]: number[]
		[CustomerInvoiceListLabels.CreateDate]: BasicString
	}

	namespace BackupDocument {
		interface Basic {
			[CustomerInvoiceListLabels.Name]: string
			[CustomerInvoiceListLabels.TransactionId]: number
			[CustomerInvoiceListLabels.ManifestId]: number
			[CustomerInvoiceListLabels.DocumentName]: string
			[CustomerInvoiceListLabels.DocumentType]: string
			[CustomerInvoiceListLabels.ServiceOccurrenceId]: BasicNumber
		}
	}

	interface Detailed {
		[CustomerInvoiceListLabels.Id]: number
		[CustomerInvoiceListLabels.Number]: BasicString
		[CustomerInvoiceListLabels.Customer]: CustomerEntity | null
		[CustomerInvoiceListLabels.BillingAddress]: BillingAddress
		[CustomerInvoiceListLabels.ApprovedBy]: BasicString
		[CustomerInvoiceListLabels.InvoiceDate]: BasicString
		[CustomerInvoiceListLabels.InvoiceType]: Entity | null
		[CustomerInvoiceListLabels.AccountingDate]: BasicString
		[CustomerInvoiceListLabels.InvoiceAdjustmentReason]: Entity | null
		[CustomerInvoiceListLabels.BillingAgency]: Entity | null
		[CustomerInvoiceListLabels.BaseCurrency]: Entity | null
		[CustomerInvoiceListLabels.TransactionCurrency]: CodeEntity | null
		[CustomerInvoiceListLabels.ExchangeRate]: number | null
		[CustomerInvoiceListLabels.TotalInvoiceAmount]: number
		[CustomerInvoiceListLabels.CustomerSendDate]: BasicString
		[CustomerInvoiceListLabels.CustomerReceivedDate]: BasicString
		[CustomerInvoiceListLabels.CreateDate]: BasicString
		[CustomerInvoiceListLabels.InvoiceContact]: Entity
		[CustomerInvoiceListLabels.InvoiceStatus]: Entity
		[CustomerInvoiceListLabels.InvoiceStatusReason]: NameCode
		[CustomerInvoiceListLabels.CustomBillFreqCode]: Entity
		[CustomerInvoiceListLabels.PurchaseOrder]: PurchaseOrder
		[CustomerInvoiceListLabels.Comments]: BasicString
		[CustomerInvoiceListLabels.InternalComments]: BasicString
		[CustomerInvoiceListLabels.PmInvoiceReviewComments]: string[]
		[CustomerInvoiceListLabels.ReferencesInvoiceIds]: number[]
		[CustomerInvoiceListLabels.ReferencedByInvoiceIds]: number[]
		[CustomerInvoiceListLabels.CustomerInvoiceAdjustments]: CustomerInvoiceAdjustments[]
		[CustomerInvoiceListLabels.ReportId]: number | null
		[CustomerInvoiceListLabels.CustomerExternalInvoice]: InvoiceAdjustmentCustomerExternalInvoice | null
		[CustomerInvoiceListLabels.efacturaInternalComments]: BasicString
		[CustomerInvoiceListLabels.customerFacturaNumber]: BasicString
		[CustomerInvoiceListLabels.facturaReceiptDate]: BasicString
		[CustomerInvoiceListLabels.pedimentoNumber]: BasicString
		[CustomerInvoiceListLabels.pedimentoDate]: BasicString
		[CustomerInvoiceListLabels.StatusChangeDate]: BasicString
		[CustomerInvoiceListLabels.InvoiceEmailTransmissionStatus]: InvoiceEmailTransmissionStatus | null
		[CustomerInvoiceListLabels.invoiceDateUpdateBy]: {
			firstName: string
			lastName: string
		} | null
		[CustomerInvoiceListLabels.invoiceDateUpdateDate]: BasicString
		[CustomerInvoiceListLabels.isRebill]: boolean
		[CustomerInvoiceListLabels.invoiceType]: Entity | null
		[CustomerInvoiceListLabels.agingReason]: Entity | null
		[CustomerInvoiceListLabels.overdueDays]: BasicString
		[CustomerInvoiceListLabels.serviceSites]: ServiceSiteExtended[]
		[CustomerInvoiceListLabels.HasInvoiceContact]: boolean
		[CustomerInvoiceListLabels.displayZeroItems]: boolean
	}

	namespace Search {
		interface Result {
			[CustomerInvoiceListSearchResultFields.ids]: number[]
			[CustomerInvoiceListSearchResultFields.customerIds]: Entity[]
			[CustomerInvoiceListSearchResultFields.customeNames]: Entity[]
			[CustomerInvoiceListSearchResultFields.serviceSiteIds]: Entity[]
			[CustomerInvoiceListSearchResultFields.serviceSiteNames]: Entity[]
			[CustomerInvoiceListSearchResultFields.serviceSiteRefCodes]: Entity[]
			[CustomerInvoiceListSearchResultFields.contractCodes]: Entity[]
			[CustomerInvoiceListSearchResultFields.companyNames]: Entity[]
			[CustomerInvoiceListSearchResultFields.itemIds]: Entity[]
		}

		interface Config {
			[CustomerInvoiceListSearchResultFields.ids]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.customerIds]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.customeNames]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.serviceSiteIds]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.serviceSiteNames]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.serviceSiteRefCodes]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.contractCodes]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.companyIds]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.companyNames]: ConfigItem<CustomerInvoiceListSearchResultFields>
			[CustomerInvoiceListSearchResultFields.itemIds]: ConfigItem<CustomerInvoiceListSearchResultFields>
		}
	}

	namespace ExtraSearch {
		namespace Factura {
			interface Config {
				[CustomerInvoiceListExtraSearchFields.efactura]: ConfigItem<CustomerInvoiceListExtraSearchFields>
				[CustomerInvoiceListExtraSearchFields.customerfactura]: ConfigItem<CustomerInvoiceListExtraSearchFields>
			}
			interface Result {
				externalInvoices: {
					id: number
					name: string
					number: string
					isCanceled: boolean
				}[]
				customerInvoices: {
					id: number
					name: string
					number: string
					isCanceled: boolean
				}[]
			}
		}

		interface SearchSelectResult {
			id: number
			prefix: string
			firstName: string
			mi: string
			lastName: string
			suffix: string
			email: string
			mailCode: string
			pin: string
			employer: string
			jobTitle: string
			internalEmployee: string
			userId: number
			userName: string
			lastLogin: null
			mobile: string
			office: string
			fax: string
			emergency: string
			billingAgencyIds: [number]
			isActive: true
			preferredLanguageId: number
		}

		interface ProgramManagerResult extends SearchSelectResult {}

		interface AccountAdministratorResult extends SearchSelectResult {}

		interface ExceptionAssignedTo extends SearchSelectResult {}

		interface Config {
			[CustomerInvoiceListExtraSearchFields.programManagerId]: ConfigItem<CustomerInvoiceListExtraSearchFields>
			[CustomerInvoiceListExtraSearchFields.accountAdminId]: ConfigItem<CustomerInvoiceListExtraSearchFields>
		}

		interface Result {
			[CustomerInvoiceListExtraSearchFields.programManagerId]: ProgramManagerResult
			[CustomerInvoiceListExtraSearchFields.accountAdminId]: AccountAdministratorResult
		}
	}

	namespace Filter {
		interface Config {
			[CustomerInvoiceListFilterFields.startDate]: ConfigFilterItem<string, null>
			[CustomerInvoiceListFilterFields.endDate]: ConfigFilterItem<string, null>
			[CustomerInvoiceListFilterFields.billingAgency]: ConfigFilterItem<string, string>
			[CustomerInvoiceListFilterFields.statusReasonCode]: ConfigFilterItem<string, string>
			[CustomerInvoiceListFilterFields.status]: ConfigFilterItem<string, string[]>
			[CustomerInvoiceListFilterFields.showInProcessOnly]: ConfigFilterItem<string, boolean>
			[CustomerInvoiceListFilterFields.showMyServiceTeamOnly]: ConfigFilterItem<
				string,
				boolean
			>
			[CustomerInvoiceListFilterFields.searchPeriod]: ConfigFilterItem<string, null>
			[CustomerInvoiceListFilterFields.exceptionType]: ConfigFilterItem<string, string>
			[CustomerInvoiceListFilterFields.exception]: ConfigFilterItem<string, string>
			[CustomerInvoiceListFilterFields.exceptionAssignedTo]: ConfigFilterItem<string, string>
			[CustomerInvoiceListFilterFields.exceptionsOnly]: ConfigFilterItem<string, boolean>
			[CustomerInvoiceListFilterFields.overdueOnly]: ConfigFilterItem<string, boolean>
		}
	}

	namespace Service {
		interface Duplicate {
			ids: number[]
		}

		namespace Form {
			interface Edit {
				[CustomerInvoiceListLabels.ItemDescription]: string | null
				[CustomerInvoiceListLabels.ChargeTypeId]: number | null
				[CustomerInvoiceListLabels.ItemRefCode]: string | null
				[CustomerInvoiceListLabels.ServiceSite]: string | null
				[CustomerInvoiceListLabels.ActualServiceDate]: Moment | null
				[CustomerInvoiceListLabels.BillingQuantity]: number | null
				[CustomerInvoiceListLabels.BillingPrice]: number | null
				[CustomerInvoiceListLabels.OriginalExtendedPrice]: number | null
				[CustomerInvoiceListLabels.ModifiedQuantity]: string | null
				[CustomerInvoiceListLabels.ModifiedBillingPrice]: string | null
				[CustomerInvoiceListLabels.ModifiedExtendedPrice]: string | null
				[CustomerInvoiceListLabels.UnitOfMeasureId]: number | null
				[CustomerInvoiceListLabels.UpdateTransactionPounds]: number | null
				[CustomerInvoiceListLabels.BillOfLading]: string | null
				[CustomerInvoiceListLabels.BillingItemNotes]: string | null
			}
		}

		interface Basic
			extends Pick<
				CustomerInvoiceItemExtended,
				| CustomerInvoiceListLabels.Id
				| CustomerInvoiceListLabels.BillingItemId
				| CustomerInvoiceListLabels.ServiceSiteId
				| CustomerInvoiceListLabels.ServiceOccurrenceId
				| CustomerInvoiceListLabels.ItemRefCode
				| CustomerInvoiceListLabels.BillOfLading
				| CustomerInvoiceListLabels.ItemDescription
				| CustomerInvoiceListLabels.Pounds
				| CustomerInvoiceListLabels.RateExtendedPrice
				| CustomerInvoiceListLabels.Currency
			> {
			[CustomerInvoiceListLabels.ServiceDate]: BasicString
			[CustomerInvoiceListLabels.Quantity]: number | null
			[CustomerInvoiceListLabels.Unit]: Entity | null
			[CustomerInvoiceListLabels.UnitPrice]: number | null
			[CustomerInvoiceListLabels.TotalPrice]: number | null
			[CustomerInvoiceListLabels.IsLateFee]: boolean
			[CustomerInvoiceListLabels.exceptionAssignedTo]: Entity | null
			[CustomerInvoiceListLabels.ItemId]: number | null
			[CustomerInvoiceListLabels.averageQuantity]: number | null
		}
		interface Detailed extends CustomerInvoiceItemExtended {}

		namespace Request {
			interface Edit {
				[CustomerInvoiceListLabels.ItemDescription]: string | null
				[CustomerInvoiceListLabels.ChargeTypeId]: number | null
				[CustomerInvoiceListLabels.ItemRefCode]: string | null
				[CustomerInvoiceListLabels.ActualServiceDate]: string | null
				[CustomerInvoiceListLabels.ModifiedQuantity]: number | null
				[CustomerInvoiceListLabels.ModifiedBillingPrice]: number | null
				[CustomerInvoiceListLabels.ModifiedExtendedPrice]: number | null
				[CustomerInvoiceListLabels.UnitOfMeasureId]: number | null
				[CustomerInvoiceListLabels.UpdateTransactionPounds]: number | null
				[CustomerInvoiceListLabels.BillOfLading]: string | null
				[CustomerInvoiceListLabels.BillingItemNotes]: string | null
			}
		}

		namespace NonBillable {
			namespace Form {
				interface MarkAsNonBillable {
					[CustomerInvoiceListLabels.Reason]: string | null
					[CustomerInvoiceListLabels.makeSupplierServiceOccurrenceCancelled]: boolean
				}
			}
			namespace Request {
				interface MarkAsNonBillable {
					[CustomerInvoiceListLabels.Reason]: string | null
					serviceIds: number[]
					makeSupplierServiceOccurrenceCancelled: boolean
				}
			}
		}
	}

	interface SearchPeriod {
		name: string
		to: string
		from: string
	}

	namespace Exception {
		interface Basic {
			id: number
			customerInvoiceException:
				| (Entity & {
						customerInvoiceExceptionType: Entity | null
				  })
				| null
			assignedTo: Entity | null
			isResolved: boolean
			comment: BasicString
			createDate: BasicString
			author: Entity | null
		}

		namespace Form {
			interface Add {
				exceptionFormType: ExceptionFormType
				exceptionTypeId: BasicNumber
				customerInvoiceExceptionId: BasicNumber
				assignedToId: BasicNumber | null
				comment: string
			}
		}

		namespace Request {
			interface Add {
				customerInvoiceExceptionId: BasicNumber
				assignedToId: BasicNumber
				comment: BasicString
			}
		}

		namespace AssignException {
			namespace Search {
				interface Result {
					id: number
					firstName: BasicString
					lastName: BasicString
					serviceTeamRole: BasicString
				}
			}
		}
	}

	namespace AgingReason {
		namespace Form {
			interface Add {
				agingReasonId: number | null
			}
		}

		namespace Request {
			interface Add {
				agingReasonId: number
			}
		}
	}
}
